import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-kefu",
  "use": "icon-kefu-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-kefu\"><defs><style>#icon-kefu .cls-1{fill:currentColor;}</style></defs><path class=\"cls-1\" d=\"M22.42,18.73a5.43,5.43,0,0,1-5,4.17v0H11.58V21.26h5.83a3.16,3.16,0,0,0,3.24-2.53H17.41v-6l.76-.76h1.75v-.84h0c0-.14,0-.28,0-.42,0-3.95-3.55-7.16-7.92-7.16S4.08,6.79,4.08,10.74A6.57,6.57,0,0,0,4.21,12H5.75l.83.79v5.94h-5V10.32C1.58,5.2,6.24,1.06,12,1.06S22.42,5.2,22.42,10.32v8.41Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol